// Touch screens: a short vibration on every button press (Android; iOS web
// pages cannot vibrate) and a pressed look that also shows on devices where
// :active fires late. Installed once for the whole app.
const HAPTIC_MS = 10;

export const installPressFeedback = (win = window) => {
  if (!win || win.__rentosPressFeedback) return () => {};
  win.__rentosPressFeedback = true;
  const target = event => event.target?.closest?.('button:not(:disabled), [role="button"]');
  const down = event => {
    const button = target(event);
    if (!button) return;
    button.classList.add('is-pressed');
    if (event.pointerType === 'touch' && typeof win.navigator?.vibrate === 'function') {
      try { win.navigator.vibrate(HAPTIC_MS); } catch { /* not allowed */ }
    }
  };
  const up = () => win.document.querySelectorAll('.is-pressed').forEach(button => button.classList.remove('is-pressed'));
  win.addEventListener('pointerdown', down, { passive: true });
  ['pointerup', 'pointercancel', 'pointerleave', 'blur'].forEach(name => win.addEventListener(name, up, { passive: true }));
  return () => {
    win.removeEventListener('pointerdown', down);
    ['pointerup', 'pointercancel', 'pointerleave', 'blur'].forEach(name => win.removeEventListener(name, up));
    delete win.__rentosPressFeedback;
  };
};
